import React from 'react';
import { Typography, Divider, IconButton, Checkbox, Stack } from '@mui/material';
import { Close } from '@mui/icons-material';
import CategoryEntry from './CategoryEntry';

function Categories({ onClose, categories, selectedCategories, setSelectedCategories, categoryColorMap, showClose, logUserAction, logActionLocation='' }) {

    const toggleCategory = (category) => {
        if (selectedCategories.includes(category)) {
            const newSelection = selectedCategories.filter(cat => cat !== category);
            setSelectedCategories(newSelection);
            logUserAction({ action: 'edited_peer_discovery_filter_category', data: { location: logActionLocation, category, status: 'deselected', current_selection: newSelection } });
        } else {
            const newSelection = [...selectedCategories, category];
            setSelectedCategories(newSelection);
            logUserAction({ action: 'edited_peer_discovery_filter_category', data: { location: logActionLocation, category, status: 'selected', current_selection: newSelection } });
        }
    };

    const toggleAllCategories = () => {
        if (selectedCategories.length === categories.length) {
            setSelectedCategories([]);
            logUserAction({ action: 'edited_peer_discovery_filter_category', data: { location: logActionLocation, status: 'none selected', current_selection: [] } });
        } else {
            setSelectedCategories([...categories]);
            logUserAction({ action: 'edited_peer_discovery_filter_category', data: { location: logActionLocation, status: 'all selected', current_selection: categories } });
        }
    };

    const allSelected = selectedCategories.length === categories.length || selectedCategories.length === 0;

    return (
        <Stack p={2} spacing={2} sx={{ minHeight: '50px' }}>
            {/* Header */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="heavy"> Filter by Supply Category </Typography>
                {showClose && (
                    <IconButton onClick={onClose} size="small">
                        <Close />
                    </IconButton>
                )}
            </Stack>
            <Divider />
            
            {/* All Supply Categories */}
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Checkbox
                    checked={allSelected}
                    onChange={toggleAllCategories}
                />
                <Typography 
                    variant={allSelected ? 'bold' : 'normal'}
                    fontSize={'14px'}
                >
                    All Supply Categories
                </Typography>
            </Stack>

            {/* Category Items */}
            <Stack spacing={0.5} pr={1} sx={{ overflowY: 'auto' }}>
                {categories.map(cat => {
                    const isSelected = selectedCategories.includes(cat);
                    return <CategoryEntry 
                        key={cat}
                        category={cat} 
                        color={categoryColorMap[cat]} 
                        isSelected={isSelected} 
                        toggleCategory={toggleCategory} 
                    />;
                })}
            </Stack>
        </Stack>
    );
}

export default Categories;